var map = {
	"./app-store-icon.svg": 6647,
	"./application-logo-generic.svg": 1164,
	"./application-logo-sa.svg": 6590,
	"./email-icon-2.svg": 8013,
	"./fido.svg": 9530,
	"./google-play-icon.svg": 1872,
	"./phone-icon.svg": 5908,
	"./push-graphic.svg": 8245,
	"./push-icon.svg": 7020,
	"./sa-favicon.svg": 9149,
	"./sa-logo-white.svg": 1690,
	"./sa-mobile-icon.svg": 3025,
	"./signout.svg": 1015,
	"./sms-icon.svg": 5529,
	"./success-icon.svg": 2423,
	"./symbol-push-icon.svg": 1919,
	"./totp-icon.svg": 2561,
	"./voice-call-icon.svg": 7929,
	"./webauthn-icon.svg": 762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2672;